import { NgModule,CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WelcomepageRoutingModule } from './welcomepage-routing.module';
import { WelcomepageComponent } from './welcomepage.component';
import { SharedModule } from 'src/app/shared';
import { WelcomepageDialogComponent } from './welcomepage-dialog/welcomepage-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [
    WelcomepageComponent,
    WelcomepageDialogComponent,
  ],

  imports: [
    WelcomepageRoutingModule,
    SharedModule,
    CommonModule,
    TranslateModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class WelcomepageModule { }
